/** MCC Trainer add/edit form helpers */

export const emptyAddForm = () => ({
  name: "",
  phone_number: "",
  iti_id: "",
  trade_id: "",
});

export const emptyEditForm = () => ({
  ...emptyAddForm(),
  id: null,
  password: "",
});

/**
 * Map GET /mcc/trainers/:id payload into edit form state.
 */
export const mapTrainerDetailToForm = (d) => ({
  id: d.id,
  name: d.name ?? "",
  phone_number: d.phone_number != null ? String(d.phone_number) : "",
  password: d.password != null ? String(d.password) : "",
  iti_id: d.iti_id != null && d.iti_id !== "" ? Number(d.iti_id) : "",
  trade_id: d.trade_id != null && d.trade_id !== "" ? Number(d.trade_id) : "",
});

/**
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export const validateTrainerMccForm = (form) => {
  const nameTrim = String(form.name ?? "").trim();
  if (!nameTrim) {
    return { ok: false, message: "Name is required" };
  }
  const phone = String(form.phone_number ?? "").trim();
  if (!/^\d{10}$/.test(phone)) {
    return { ok: false, message: "Phone number must be exactly 10 digits" };
  }
  if (!form.iti_id) {
    return { ok: false, message: "ITI is required" };
  }
  if (!form.trade_id) {
    return { ok: false, message: "Trade is required" };
  }
  return { ok: true };
};
